<template>
	<lesson-resources-by-categories v-if="getShowResources" :media="getMedia">
		<template v-slot="{ resource }">
			<lesson-resource-item :resource="resource" />
		</template>
	</lesson-resources-by-categories>
</template>

<script>

	import LessonResourcesByCategories from '@/components/lessons/LessonResourcesByCategories';
	import LessonResourceItem from '@/components/lessons/LessonResourceItem';
	import routeParams from '@/mixins/routeParams';

	export default {
		components: {
			LessonResourcesByCategories,
			LessonResourceItem
		},
		mixins: [routeParams],
		props: {
			lesson: {
				type: Object,
				default: () => ({})
			}
		},
		data () {
			return {
				hiddenCategories: [],
				hiddenCategoriesByCondition: [
					'hand_record'
				]
			};
		},
		computed: {
			getShowAllResources () {
				if (this.getContext === 'browseCourses' ||
					this.getContext === 'myCourses') {
					return false;
				}
				return true;
			},
			getAreLessonDealsCompleted () {
				return this.lesson.deals.every(deal => deal.isComplete);
			},
			getLessonIsLive () {
				return this.lesson.live;
			},
			getMedia () {
				const media = this.lesson?.media || [];
				return media.filter((item) => {
					if (this.hiddenCategoriesByCondition.includes(item?.config.type)) {
						return [
							this.getShowAllResources,
							this.getAreLessonDealsCompleted,
							this.getLessonIsLive
						].some(r => r);
					}
					return !this.hiddenCategories.includes(item?.config.type);
				});
			},
			getShowResources () {
				if (!this.getMedia?.length) {
					return false;
				}
				return true;
			}
		}
	};

</script>

<style lang="scss" scoped></style>
